import React from "react";
import { useLocale } from "../../i18n/LocaleContext";

const STEPS = [
  { n: "01", title: "Discovery & Spend Baseline", body: "Infosys analysts review your current indirect spend, vendor master and category mix. Output: a consolidation business case with savings range and tail-supplier reduction plan." },
  { n: "02", title: "Catalog Tailoring", body: "Your custom OMNISupply storefront is configured — preferred OEMs, plant-level approved SKUs, ESG/diversity flags, regional pricing and contract T&Cs." },
  { n: "03", title: "ERP Integration", body: "Pick your integration mode — PunchOut, Search API or deep ERP. Infosys delivers, tests in your sandbox, and certifies go-live with your IT team." },
  { n: "04", title: "Operate as One Vendor of Record", body: "Buyers transact. Infosys handles supplier orchestration, expediting, GRN, returns and consolidated invoicing. Procurement governs through real-time dashboards." },
];

export default function HowItWorks() {
  const { t } = useLocale();
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] text-slate-500 font-semibold mb-4">
            <span className="inline-block h-px w-8 bg-slate-300" />
            <span>{t("landing.howitworks.eyebrow")}</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl xl:text-[56px] font-semibold tracking-[-0.02em] mt-1 text-slate-900 leading-[1.05]">
            {t("landing.howitworks.headline")}
          </h2>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute left-0 right-0 top-12 h-px bg-slate-200" />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-4">
            {STEPS.map((s, i) => (
              <div
                key={s.n}
                data-testid={`step-${i}`}
                className="relative bg-white rounded-xl border border-slate-200 p-6 md:p-7 hover:border-[#0072CE] hover:shadow-md transition-all"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-10 w-10 rounded-md bg-[#0072CE] text-white flex items-center justify-center font-display font-bold">
                    {s.n}
                  </div>
                  <div className="h-px flex-1 bg-slate-200" />
                </div>
                <h3 className="font-display text-lg font-semibold tracking-tight text-slate-900">
                  {s.title}
                </h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed">
                  {s.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
